import type {Dayjs} from 'dayjs'

export const mapEntryHours = (start: Dayjs | undefined, end: Dayjs | undefined): number => {
  if (!start) return 0
  if (!end) return 0

  const diff = end.diff(start, 'minutes') / 60
  return diff >= 0 ? Math.round(diff * 100) / 100 : 0
}
